export const SET_CONSUMER_ACCEPTED_TNC = 'app/consumer/SET_CONSUMER_ACCEPTED_TNC';
export const SET_CONSUMER_AGGREGATED_SETTINGS = 'app/consumer/SET_CONSUMER_AGGREGATED_SETTINGS';
export const SET_CONSUMER_DATA = 'app/consumer/SET_CONSUMER_DATA';
export const SET_CONSUMER_PRODUCTS = 'app/consumer/SET_CONSUMER_PRODUCTS';
export const SET_CONSUMER_TNC = 'app/consumer/SET_CONSUMER_TNC';
export const UPDATE_IOT_PRODUCT_DATA = 'app/consumer/UPDATE_IOT_PRODUCT_DATA';

const initialData = {
    acceptedTnc: undefined,
    aggregatedSettings: undefined,
    data: undefined,
    products: undefined,
    productsAsset: [],
    tnc: undefined,
};

export default function reducer(state = initialData, action) {
    switch (action.type) {
        case SET_CONSUMER_AGGREGATED_SETTINGS: {
            return {
                ...state,
                aggregatedSettings: action.payload,
            };
        }
        case SET_CONSUMER_PRODUCTS: {
            return {
                ...state,
                products: action.payload,
            };
        }
        case SET_CONSUMER_DATA: {
            return {
                ...state,
                data: action.payload,
            };
        }
        case SET_CONSUMER_TNC: {
            return {
                ...state,
                tnc: action.payload,
            };
        }
        case SET_CONSUMER_ACCEPTED_TNC: {
            return {
                ...state,
                acceptedTnc: action.payload,
            };
        }
        case UPDATE_IOT_PRODUCT_DATA: {
            return {
                ...state,
                iotProduct: action.payload,
            };
        }
        default:
            return state;
    }
}

export const setConsumerAcceptedTnc = (data) => ({
    type: SET_CONSUMER_ACCEPTED_TNC,
    payload: data,
});
export const setConsumerAggregatedSettings = (data) => ({
    type: SET_CONSUMER_AGGREGATED_SETTINGS,
    payload: data,
});
export const setConsumerData = (data) => ({
    type: SET_CONSUMER_DATA,
    payload: data,
});
export const setConsumerProducts = (data) => ({
    type: SET_CONSUMER_PRODUCTS,
    payload: data,
});
export const setConsumerTnc = (data) => ({
    type: SET_CONSUMER_TNC,
    payload: data,
});
